/**
 * Domain logic for the Invoice Storno page (legacy Delphi `ufrmStorno.pas`).
 *
 * Storno issues a credit note against a goods-sale (`V.Marfa`) invoice: the
 * original is flagged credited, a negated `Storno` counter-invoice is written
 * and the goods return to shop stock.
 */

/**
 * Invoice type of the goods-sale (`V.Marfa`) documents listed on the storno
 * page. Passed as the preview `documentType` so the pre-issuance preview always
 * renders the RO goods-sale template (`Factură Vânzare Marfă (RO)`) with the
 * sold-goods lines, rather than falling back to a storno/commission layout.
 */
export const INVOICE_TYPE_GOODS_SALE = 'V.Marfa';

/** A goods-sale invoice eligible for storno, as returned by the backend. */
export interface StornoInvoice {
    id: number;
    invoiceNumber: string | null;
    invoiceDate: string | null;
    contractNumber: string | null;
    clientName: string | null;
    amount: number;
    itemName: string | null;
}

/** The outcome of a storno operation, as returned by the backend. */
export interface StornoResult {
    originalInvoiceNumber: string;
    stornoInvoiceNumber: string;
    contractNumbers: string[];
    amount: number;
}

/** Round a currency amount to whole RON for display, per project display rules. */
export function formatStornoAmount(amount: number | null | undefined): string {
    const value = Number(amount ?? 0);
    return Number.isFinite(value) ? Math.round(value).toString() : '0';
}

/**
 * A stable React key for an invoice row, tolerant of the (theoretical) case
 * where the invoice number is missing.
 */
export function stornoRowKey(invoice: StornoInvoice): string {
    return invoice.invoiceNumber ?? `id-${invoice.id}`;
}
